import React from "react"

import "./ArrowLink.scss"

const ArrowLink: React.FC<React.PropsWithChildren<{href?: string, onClick?(): void}>> = ({href, onClick, children}) => {
  return <a href={href} className="neo__ArrowLink" onClick={onClick}>{children}</a>
}

export default ArrowLink
